export const layout = {
  namespaced: true,
  state: {
    drawer: true,
    title: "",
    overlay: { value: false, title: "" },
  },
  getters: {
    DRAWER_VALUE(state) {
      return state.drawer;
    },
    TITLE_VALUE(state) {
      return state.title;
    },
    OVERLAY_VALUE(state) {
      return state.overlay;
    },
  },
  mutations: {
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_TITLE(state, payload) {
      state.title = payload;
    },
    SET_OVERLAY(state, payload) {
      state.overlay = payload;
    },
    CLEAR_TITLE(state) {
      state.title = "";
    },
  },
  actions: {},
};
